import operations from '@/lib/ondit/batch-operations.json'
import { OnditBlock } from '@/blocks/blocks/ondit'
import type { BlockConfig } from '@/blocks/types'

export const OnditBatchBlock: BlockConfig = {
  ...OnditBlock,
  type: 'ondit_batch',
  name: 'Optimization batch',
  description:
    'Review pages, draft directions, or publish approved revisions with individual results',
  subBlocks: OnditBlock.subBlocks.map((field) =>
    field.id === 'capability'
      ? {
          ...field,
          options: operations.map((operation) => ({ id: operation.id, label: operation.label[0] })),
        }
      : field
  ),
}
